<!--
  navItem "Basisdaten" — metadata driven master form through the object widget
  (mvs-widget-object -> mvs-crud-object). No hand-written form HTML.
-->
<div class="cp-provision-type-base-data">

    @if (initialized && baseFormWidget) {
        <mvs-widget [widgetData]="baseFormWidget"></mvs-widget>
    } @else if (initialized) {
        <p-message severity="info" text="Kein Provisionstyp ausgewählt." styleClass="w-full"></p-message>
    } @else {
        <p-skeleton height="12rem"></p-skeleton>
    }

</div>
